import gql from 'graphql-tag';
export default gql`
  query vehicleOptions($variantId: String) {
    vehicleOptions(variantId: $variantId) {
      exteriorColours {
        id
        code
        name
        standard
        requires
        precludes
      }
      interiorColours {
        id
        code
        name
        standard
        requires
        precludes
      }
      optionalEquipment {
        id
        code
        name
        amountNet
        precludes
      }
      includedEquipment {
        id
        code
        name
        amountNet
      }
    }
  }
`;
